import React from 'react';
import { cn } from '../utils/cn';

interface CoverImageProps {
  src?: string;
  alt?: string;
  className?: string;
}

export const CoverImage: React.FC<CoverImageProps> = ({
  src,
  alt = '',
  className,
}) => {
  if (!src) return null;

  return (
    <div className="mb-6">
      <img
        src={src}
        alt={alt}
        className={cn('w-full h-auto rounded-lg', className)}
        onError={(e) => {
          e.currentTarget.style.display = 'none';
        }}
      />
    </div>
  );
};
